import { useAtomValue } from 'jotai';
import { isLoggedInAtom } from 'app/atoms';
import { useUser } from 'app/network/user';
import { FeatureFlag, isFeatureEnabled } from 'app/utils/helpers';

/** Read effective API flags for members; preserve static defaults before login/profile loading. */
export function useLandingDiscoveryFeatures() {
  const isLoggedIn = useAtomValue(isLoggedInAtom);
  const { data: user } = useUser();
  const featureFlags = isLoggedIn ? user?.featureFlags : undefined;
  return {
    featureFlags,
    showDiscoveryFeeds: isFeatureEnabled(FeatureFlag.showDiscoveryFeeds, featureFlags),
    showLandingCategories: isFeatureEnabled(FeatureFlag.showLandingCategories, featureFlags),
  };
}
